import React, {useRef} from 'react';
import UploadIcon from "../../../../../assets/images/icon_upload.svg";
import ImageFileUploader, {RefAttr} from "../../helpers/ImageFileUploader";
import {useTranslation} from "react-i18next";
import {AssetBoxContainer, AssetBoxWrapper, AssetLabel} from './AssetBoxStyle';


interface AssetBoxUploadProps {
    handleFileSelect: (file: File | null) => void;
    allowVideo?: boolean;
}

const AssetBoxUpload: React.FC<AssetBoxUploadProps> = ({
                                                           handleFileSelect,
                                                           allowVideo = false
                                                       }) => {
    const {t} = useTranslation();

    const uploadRef = useRef<RefAttr>(null);

    return (
        <AssetBoxContainer
            item
            xs={4}
            md={3}
        >
            <AssetBoxWrapper
                onClick={() => uploadRef.current?.handleUploadClick()}
            >

                <img
                    src={UploadIcon}
                    width="36px"
                    height="36px"
                    style={{
                        display: "block",
                        objectFit: "contain",
                        margin: "auto",
                    }}
                />

                <ImageFileUploader onFileSelect={handleFileSelect} allowVideo={allowVideo} ref={uploadRef}/>
            </AssetBoxWrapper>
            <AssetLabel>{t("editor.select.upload")}</AssetLabel>
        </AssetBoxContainer>
    );
};

export default AssetBoxUpload;
